module.exports = __webpack_public_path__ + "img/user-for-openbadge-v3-2.15dc1cea.png";